import { DateCell, dateFormatter, formattedCell } from '@dec/shared';
import { type ColDef } from 'ag-grid-community';
import { t } from 'i18next';
import { Search } from 'react-bootstrap-icons';

import { ActionsGrid } from '@/app/components/grid';
import { type ActionColumn } from '@/app/components/grid/actions-column';

import { type DisbursementSummary } from '../../models/Disbursement';

export const getPaymentColumns = (
  onView: (row: DisbursementSummary) => void
): Array<ColDef<DisbursementSummary>> => {
  const actions: Array<ActionColumn> = [
    {
      icon: Search,
      variant: 'secondary',

      onClick: async (row: DisbursementSummary) => {
        // se invoca al método para apertura
        onView(row);
      }
    }
  ];

  const columns: Array<ColDef<DisbursementSummary>> = [
    {
      headerName: t('taxes.header.actions'),
      cellRenderer: ActionsGrid,
      cellRendererParams: {
        actions: actions
      }
    },
    {
      headerName: t('disbursement.disbursementDate'),
      field: 'disbursementDate',
      ...formattedCell(dateFormatter, DateCell)
    },
    {
      headerName: t('disbursement.comments'),
      field: 'comments'
    }
  ];

  return columns;
};
